import React, { useEffect } from "react";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import DragDropfile from "../../../form/DragDropfile";
import { publicationAddEdit } from "../../../../services/publicationService";
import { categoryList } from "../../../../services/catagoryService";
import { useState } from "react";
import { useDebounce } from "../../../../hooks/useDebounce";
import useFetch from "../../../../hooks/useFetch";
import { removeDuplicateFromArray } from "../../../../helpers";
import { changePassword } from "../../../../services/ProfileService";
import { toast } from "react-toastify";

const validation = {
  confirmPassword: { required: true, message: "Confirm Password is Required" },
  currentPassword: { required: true, message: "Current Password is Required" },
  newPassword: [
    {
      type: "password",
      minLength: 8,
      required: true,
      message:
        "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
    },
  ],
};

const ManagePassword = ({ close = () => {}, data }) => {
  useEffect(() => {
    if (data?._id) {
      setFieldsValue(data);
    }
  }, [data]);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      title: "",
      categoryType: "",
      image: "",
    },
  });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await changePassword({
        ...val,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      if (res?.status == 200 || res?.status == 201) {
        toast.success(res.message);
      } else {
        toast.warning(res?.error || res?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-6 py-6 xls:pr-10">
        <div className="col-span-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="">
              <Input
                label="Current Password"
                inputPlaceholder={"Enter Current Password"}
                inputName="currentPassword"
                value={values?.currentPassword}
                inputClasses={"!h-11 md:!h-10"}
                labelClasses={"!text-xs !text-slate-600"}
                onChange={handleChange}
                {...formValidate(errors, "currentPassword")}
              />
            </div>
            <div className="">
              <Input
                label="New Password"
                inputPlaceholder={"Enter New Password"}
                inputName="newPassword"
                value={values?.newPassword}
                inputClasses={"!h-11 md:!h-10"}
                labelClasses={"!text-xs !text-slate-600"}
                onChange={handleChange}
                {...formValidate(errors, "newPassword")}
              />
            </div>
            <div className="">
              <Input
                label="Confirm Password"
                inputPlaceholder={"Enter Confirm Password"}
                inputName="confirmPassword"
                value={values?.confirmPassword}
                inputClasses={"!h-11 md:!h-10"}
                labelClasses={"!text-xs !text-slate-600"}
                onChange={handleChange}
                {...formValidate(errors, "confirmPassword")}
              />
            </div>
          </div>
          <div className="relative col-span-4 mt-5">
            <div className="flex items-center justify-end gap-4">
              <Button
                buttonType="submit"
                buttonLabel={"Save"}
                buttonLabelClasses={"!text-sm"}
                buttonIcon={"fa-light fa-floppy-disk"}
                buttonIconPosition={"left"}
                buttonClasses="!py-2 !px-2 rounded-lg text-white !h-auto !bg-chestnut-rose hover:!bg-red-600"
                {...(isLoading && {
                  loading: true,
                  buttonIconPosition: "left",
                  isDisable: true,
                })}
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ManagePassword;
